import React from "react";
import { NavLink } from "react-router-dom";

const RentalValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold">
        Rental Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Rental determination or rent reviews are required when the rent review
          in a lease reverts to market or where either party to the lease
          disagree with the rental. Our licensed independent valuers have over
          ten (10) years experience in providing rental valuations.
        </p>
      </div>

      <p className="font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default RentalValuationTab;
